<div class="header-container clearfix">
    <div class="row">
        <div class="col-6 col-lg-10 d-flex align-items-center">
            <h5 class="mb-0">{{ 'filters.title' | translate }}</h5>
        </div>
        <div class="col-6 col-lg-2 d-flex align-items-center justify-content-end">
            <a (click)="changeFilters($event)" type="button"
                [ngClass]="{'no-results': documents && documents.length < 1}" class="green-link"><span
                    [ngClass]="{'blink': documents && documents.length < 1}">{{'filters.change' | translate }}</span></a>
        </div>
    </div>

    <div class="row px-3">
        <ng-container *ngFor="let filter of filtersKey">
            <div *ngIf="hasInfo(filter)" class="filter-item mx-2 my-1">
                <span class="px-2 badge badge-light">
                    <span class="title">{{'filters.list.'+filter | translate }}</span>
                    <span class="description">{{filter === 'signed' ? (filtersInfo[filter] | translate) : filtersInfo[filter] }}</span>
                </span>
            </div>
        </ng-container>
    </div>

</div>